<template>
	<span class="term-tooltip" @mouseenter="open" @mouseleave="close">
		<button
			ref="trigger"
			type="button"
			class="term-tooltip__trigger"
			:aria-label="label"
			@focus="open"
			@blur="close"
		>
			<img src="@/assets/images/icons/tooltip-plan.png" alt="" class="w-4 h-4">
		</button>
		<Teleport to="body">
			<div
				v-if="visible"
				ref="bubble"
				class="term-tooltip__bubble"
				:class="{ 'is-ready': ready }"
				:style="bubbleStyle"
				role="tooltip"
			>
				{{ text }}
				<span class="term-tooltip__arrow" :style="arrowStyle"></span>
			</div>
		</Teleport>
	</span>
</template>

<script>
import { nextTick } from 'vue';

export default {
	name: 'TermTooltip',
	props: {
		text: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			default: 'Giải thích',
		},
	},
	data() {
		return {
			visible: false,
			ready: false,
			bubbleStyle: {},
			arrowStyle: {},
		};
	},
	methods: {
		async open() {
			this.visible = true;
			this.ready = false;
			await nextTick();
			const triggerEl = this.$refs.trigger;
			const bubbleEl = this.$refs.bubble;
			if (!triggerEl || !bubbleEl) return;

			const rect = triggerEl.getBoundingClientRect();
			const width = bubbleEl.offsetWidth;
			const height = bubbleEl.offsetHeight;
			const gap = 10;
			let left = rect.left + rect.width / 2 - width / 2;
			const maxLeft = window.innerWidth - width - 8;
			left = Math.max(8, Math.min(left, maxLeft));
			const top = Math.max(8, rect.top - height - gap);
			this.bubbleStyle = {
				top: `${top}px`,
				left: `${left}px`,
			};
			const arrowLeft = rect.left + rect.width / 2 - left - 13;
			this.arrowStyle = {
				left: `${Math.max(16, Math.min(arrowLeft, width - 42))}px`,
			};
			this.ready = true;
		},
		close() {
			this.visible = false;
			this.ready = false;
		},
	},
};
</script>

<style scoped>
.term-tooltip {
	display: inline-flex;
	align-items: center;
	flex-shrink: 0;
}

.term-tooltip__trigger {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	margin: 0;
	padding: 4px;
	border: 0;
	background: transparent;
	line-height: 0;
	cursor: pointer;
}

.term-tooltip__bubble {
	position: fixed;
	z-index: 80;
	box-sizing: border-box;
	width: max-content;
	max-width: 449px;
	padding: 16px;
	border-radius: 5px;
	background: #f6d692;
	color: #344256;
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
	letter-spacing: normal;
	text-align: left;
	text-transform: none;
	white-space: normal;
	box-shadow: 0 0 1px rgba(12, 26, 75, 0.1),
		0 4px 20px -2px rgba(50, 50, 71, 0.08);
	pointer-events: none;
	opacity: 0;
}

.term-tooltip__bubble.is-ready {
	opacity: 1;
}

.term-tooltip__arrow {
	position: absolute;
	bottom: -12px;
	width: 0;
	height: 0;
	border-left: 13px solid transparent;
	border-right: 13px solid transparent;
	border-top: 12px solid #f6d692;
}
</style>
